import { ScreenBase } from "@frui.ts/screens/dist";
import { interfaces } from "inversify";
import { action, computed } from "mobx";
import LocalizationService from "services/localizationService";
import ChargeDetailResponse from "entities/chargeDetailResponse";

export default class CodeChangedAlertViewModel extends ScreenBase {
  constructor(private charge: ChargeDetailResponse, private localizationService: LocalizationService) {
    super();
  }

  @computed
  get code() {
    return this.charge.authCode;
  }

  @computed
  get emailAddress() {
    if (this.charge.emailAddress) return this.charge.emailAddress;
    return "";
  }

  @computed
  get description() {
    return this.translate("description")
      .replace("%email%", this.emailAddress)
      .replace("%code%", this.code || "");
  }

  @action.bound
  onHide() {
    this.requestClose();
  }

  translate(code: string) {
    return this.localizationService.translateGeneral(`chargeManagement.codeChanged.${code}`);
  }

  static Factory({ container }: interfaces.Context) {
    return (charge: ChargeDetailResponse) => {
      return new CodeChangedAlertViewModel(charge, container.get(LocalizationService));
    };
  }
}
